'use strict';

var RulesReadonlyCustomDirective = function RulesReadonlyCustomDirective() {
  return {
    restrict: 'E',
    replace: true,
    require: '^rmRulesReadonly',
    template: require('../templates/rules-readonly-custom.html')
  };
};
RulesReadonlyCustomDirective.$inject = [];
module.exports = RulesReadonlyCustomDirective;